import { useEffect, useRef } from 'react';

const useIsMounted = () => {
  const refIsMounted = useRef(false);

  useEffect(() => {
    refIsMounted.current = true; // Set to true when mounted
    return () => {
      refIsMounted.current = false; // Set to false when unmounted
    };
  }, []);

  return refIsMounted;
};
export default useIsMounted;
